'use client';

import { Avatar, AvatarFallback, AvatarImage, cn } from 'ui';

export function CommentAvatar({
  name,
  image,
  className,
}: {
  name: string;
  image?: string | null;
  className?: string;
}) {
  return (
    <Avatar className={cn('size-8', className)}>
      {image && <AvatarImage src={image} alt="" />}
      <AvatarFallback className="text-xs">
        {name.slice(0, 2).toUpperCase() || '–'}
      </AvatarFallback>
    </Avatar>
  );
}
